export default function Legend({
  label,
  color,
  icon,
}: {
  label: string;
  color: "green" | "red";
  icon: string;
}) {
  return (
    <div className="flex items-center gap-1.5">
      <span
        className={`flex h-4 w-4 items-center justify-center rounded-full bg-${color}-500`}
      >
        <i className={`${icon} text-[12px] text-white`} />
      </span>
      <span className="font-medium text-neutral-950">{label}</span>
    </div>
  );
}
